import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  SxProps,
  Typography,
} from "@mui/material";
import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { ShippingStatus } from "../types";
import LabeledTextField from "./LabeledTextField";
import LabeledSelect from "./LabeledSelect";
import { shippingStatusList } from "../constants";
import LabeledComponent from "./LabeledComponent";
import { checkBusinessDate, removeEmptyValues } from "../utils/common";
import DateOrTextField from "./DateOrTextField";
import downloadOrderSupplierCsv from "../api/downloadOrderSupplierCsv";

type Props = {
  open: boolean;
  onClose: Function;
  downloadCsv: (dlMode: 0 | 1) => Promise<void>;
};

type RadioIndex = 0 | 1;

const radioOptions = [
  "未ダウンロードの注文のみ",
  "全ての注文",
  // '未ダウンロード + ダウンロード済みの受注',
  // '未ダウンロード + ダウンロード済みの受注（期間指定）',
];

const styles: { [key: string]: SxProps } = {
  searchRowBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  searchRowBox3: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    width: "464px",
  },
};

/**
 * 本部依頼一覧CSVダウンロードモード選択モーダル
 * @param root0 コンポーネントのプロップス
 */
export default function SelectAskDownloadMode({ open, onClose, downloadCsv }: Props) {
  const [dlMode, setDlMode] = useState<RadioIndex>(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const index = parseInt(e.target.value, 10) as RadioIndex;
    setSelectedIndex(index);
    setDlMode(index);
  };


  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      PaperProps={{
        sx: {
          minWidth: 550,
          // width: '80vw',
          maxWidth: 1200,
        },
      }}
    >
      <DialogTitle>本部依頼CSVダウンロード</DialogTitle>
      <DialogContent>
        <Grid container direction="column" spacing={2}>
          {/* フォーム */}
          <Grid item container justifyContent="center">
            <Grid item textAlign="center" justifyItems="center" my={1} mr={0}>

              <FormControl component="fieldset">
                <FormLabel component="legend">ダウンロードするデータを選択してください。</FormLabel>
                <RadioGroup value={String(selectedIndex)} onChange={handleChange}>
                  {radioOptions.map((o, i) => (
                    <FormControlLabel
                      // eslint-disable-next-line react/no-array-index-key
                      key={i}
                      value={String(i)}
                      control={<Radio />}
                      label={o}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              {/* <Box sx={styles.searchRowBox3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="注文日（開始）"
                    format="YYYY/MM/DD"
                    maxDate={endDate ? dayjs(endDate) : dayjs().add(1,'day')}
                    value={startDate ? dayjs(startDate, "YYYY/MM/DD") : null}
                    onChange={(val) => setStartDate(val ? val.format("YYYY/MM/DD") : "")}
                    slotProps={{ textField: { size: "small" } }}
                    sx={{
                      width: "calc(50% - 16px)",
                      margin: "8px",
                    }}
                    disabled={selectedIndex !== 3}
                  />
                </LocalizationProvider>
                <Box width="16px" textAlign="center" lineHeight="54px">
                  ～
                </Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="注文日（終了）"
                    format="YYYY/MM/DD"
                    maxDate={dayjs().add(1,'day')}
                    minDate={startDate ? dayjs(startDate) : undefined}
                    value={endDate ? dayjs(endDate, "YYYY/MM/DD") : null}
                    onChange={(val) => setEndDate(val ? val.format("YYYY/MM/DD") : "")}
                    slotProps={{ textField: { size: "small" } }}
                    sx={{
                      width: "calc(50% - 16px)",
                      margin: "8px",
                    }}
                    disabled={selectedIndex !== 3}
                  />
                </LocalizationProvider>
              </Box> */}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="custom-outlined" onClick={() => onClose()}>
          キャンセル
        </Button>
        <Button
          variant="contained"
          onClick={async () => {
            await downloadCsv(dlMode);
            // await downloadOrderSupplierCsv(removeEmptyValues({
            //   dl_mode: dlMode === 1 ? 1 : 0,
            //   // dl_mode: dlMode === 1 ? undefined : 0,
            //   // from: startDate,
            //   // to: endDate
            // }));
            onClose();
          }}
        >
          CSVダウンロード
        </Button>
      </DialogActions>
    </Dialog>
  );
}
